import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonContainer from '@mui/material/ToggleButtonGroup';
import { cgtag } from 'utilities/gtag';
import Box from '@mui/material/Box';
import find from 'lodash/find';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

interface Option {
  value: string;
  label: string;
  helperText?: string;
}

interface ToggleButtonGroupProps {
  name: string; // Used for analytics purposes only
  value: string;
  items: Option[];
  fullWidth?: boolean;
  onChange: (event: React.SyntheticEvent<Element, Event>, newValue: string) => void;
  rootSx?: SxProps<Theme>;
  helperSx?: SxProps<Theme>;
}

const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({ name, fullWidth = true, value, items, onChange, rootSx = {}, helperSx = {} }) => {
  const currentItem = find(items, ['value', value]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ...rootSx }}>
      <ToggleButtonContainer
        fullWidth={fullWidth}
        size="large"
        value={value}
        exclusive
        onChange={(ev, newValue) => {
          cgtag('radio_button', {
            radio_button_name: name,
            selected_option: newValue,
          });
          onChange(ev, newValue);
        }}
      >
        {items.map((Item: Option, idx: number) => (
          <ToggleButton
            // classes={{
            //   label: classes.labelText,
            // }}
            key={'idx-' + idx + '-' + Item.value}
            disableRipple
            value={Item.value}
          >
            {Item.label}
          </ToggleButton>
        ))}
      </ToggleButtonContainer>
      {currentItem?.helperText && (
        <Box
          sx={{
            maxWidth: 400,
            mt: 1.5,
            textAlign: 'center',
            typography: 'subtitle1',
            color: 'text.secondary',
            ...helperSx,
          }}
        >
          {currentItem?.helperText}
        </Box>
      )}
    </Box>
  );
};

export default ToggleButtonGroup;
